// extraDetailsConfig.ts

export interface ExtraDetailsConfig {
  [serviceName: string]: {
    fields: {
      key: string;
      label: string;
      type?: 'text' | 'select' | 'number' | 'boolean';
      options?: string[];
      group?: string;
    }[];
  };
}

export const extraDetailsConfig: ExtraDetailsConfig = {
  'Cooking Service': {
    fields: [
      { key: 'cuisine', label: 'Cuisine Type', type: 'text' },
      { key: 'vegNonVeg', label: 'Food Preference', type: 'select', options: ['Veg', 'Non-Veg', 'Vegan'] },
      { key: 'people', label: 'Number of People', type: 'number' },
      { key: 'allergies', label: 'Allergies', type: 'text' },
      { key: 'diet', label: 'Diet/Menu Preferences', type: 'text' },
      { key: 'providingRecipe', label: 'Providing Recipe', type: 'select', options: ['Yes', 'No'] }
    ]
  },
  'Nanny Service': {
    fields: [
      { key: 'kids', label: 'Number of Kids', type: 'number' },
      { key: 'age', label: 'Age', type: 'number' },
      { key: 'allergies', label: 'Allergies', type: 'select', options: ["Yes", "No"] },
      { key: 'diet', label: 'Diet/Menu Preferences', type: 'text' },
      { key: 'emergency1Name', label: 'Name', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency1Phone', label: 'Phone Number', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency1Relation', label: 'Relationship', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency2Name', label: 'Name', type: 'text', group: 'Emergency Contact 2' },
      { key: 'emergency2Phone', label: 'Phone Number', type: 'text', group: 'Emergency Contact 2' },
      { key: 'emergency2Relation', label: 'Relationship', type: 'text', group: 'Emergency Contact 2' }
    ]
  },
  'Nanny & Babysitting Service': {
    fields: [
      { key: 'specialNeeds', label: 'Special Needs', type: 'select', options: ['Yes', 'No'] },
      { key: 'kids', label: 'Number of Kids', type: 'number' },
      { key: 'ages', label: 'Ages', type: 'text' },
      { key: 'allergies', label: 'Allergies', type: 'select', options: ["Yes", "No"] },
      { key: 'diet', label: 'Diet/Menu Preferences', type: 'text' },
      { key: 'emergency1Name', label: 'Name', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency1Phone', label: 'Phone Number', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency1Relation', label: 'Relationship', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency2Name', label: 'Name', type: 'text', group: 'Emergency Contact 2' },
      { key: 'emergency2Phone', label: 'Phone Number', type: 'text', group: 'Emergency Contact 2' },
      { key: 'emergency2Relation', label: 'Relationship', type: 'text', group: 'Emergency Contact 2' }
    ]
  },
  'Housekeeping Service': {
    fields: [
      { key: 'homeType', label: 'Type of Home', type: 'select', options: ["Condo", "Townhouse", "Detached", "Duplex", "Mobile Home"] },
      { key: 'rooms', label: 'No. of Rooms', type: 'number' },
      { key: 'washrooms', label: 'No. of Washrooms', type: 'number' }
    ]
  },
  'Cleaning Service': {
    fields: [
      { key: 'homeType', label: 'Type of Home', type: 'select', options: ["Condo", "Townhouse", "Detached", "Duplex", "Mobile Home"] },
      { key: 'rooms', label: 'No. of Rooms', type: 'number' },
      { key: 'washrooms', label: 'No. of Washrooms', type: 'number' },
      { key: 'supplies', label: 'Include Supplies?', type: 'select', options: ["Yes", "No"] },
      { key: 'cleaningType', label: 'Type of Cleaning', type: 'select', options: ["Routine", "Deep Cleaning", "Move in/Move out"] }
    ]
  },
  'Salon Service': {
    fields: [
      { key: 'people', label: 'No. of People', type: 'number' },
      { key: 'service', label: 'Service Required', type: 'select', options: ["Hair cutting", "Styling", "Colouring", "Manicures", "Pedicures", "Waxing", "Facials", "Heena (Mehndi)", "Makeup Application", "Others"] },
      { key: 'supplies', label: 'Include Supplies?', type: 'select', options: ["Yes", "No"] },
      { key: 'allergies', label: 'Allergies', type: 'select', options: ["Yes", "No"] }
    ]
  },
  'Doula Service': {
    fields: [
      { key: 'motherName', label: 'Mother\'s Name', type: 'text' },
      { key: 'dueDate', label: 'Due Date / Expected Delivery', type: 'text' },
      { key: 'birthLocation', label: 'Birth Location', type: 'text' },
      { key: 'supportType', label: 'Type of Support', type: 'select', options: ["Prenatal", "Labor & Birth", "Postpartum"] },
      { key: 'birthPlan', label: 'Birth Plan Preferences', type: 'text' },
      { key: 'medicalConcerns', label: 'Medical Conditions / Concerns', type: 'text' },
      { key: 'partnerName', label: 'Partner\'s Name', type: 'text' },
      { key: 'partnerInvolvement', label: 'Partner Involvement', type: 'select', options: ["Active", "Partial", "Minimal", "Not Involved"] },
      { key: 'emergency1Name', label: 'Name', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency1Phone', label: 'Phone Number', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency1Relation', label: 'Relationship', type: 'text', group: 'Emergency Contact 1' },
      { key: 'emergency2Name', label: 'Name', type: 'text', group: 'Emergency Contact 2' },
      { key: 'emergency2Phone', label: 'Phone Number', type: 'text', group: 'Emergency Contact 2' },
      { key: 'emergency2Relation', label: 'Relationship', type: 'text', group: 'Emergency Contact 2' }
    ]
  },
  'default': {
    fields: []
  }
};

// function to get fields for a specific service
export const getExtraDetailsFields = (serviceName: string) => {
  return extraDetailsConfig[serviceName] || extraDetailsConfig['default'];
};

// function to parse and format extraDetails data
export const parseExtraDetails = (extraDetailsString: any) => {
  try {
    if (typeof extraDetailsString === 'object' && extraDetailsString !== null) {
      return extraDetailsString;
    }
    return JSON.parse(extraDetailsString);
  } catch (error) {
    console.error('Error parsing extraDetails:', error);
    return {};
  }
};

// function to render field value based on type
export const renderFieldValue = (value: any, type?: string) => {
  if (value === null || value === undefined || value === '') return '--';

  if (type === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  return value.toString();
};